"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FindOrgForm = exports.ERROR_UNEXPECTED = exports.ERROR_INVALID_SID = void 0;
const Button_1 = __importDefault(require("@targetx/mineral-ui/Button"));
const Flex_1 = __importDefault(require("@targetx/mineral-ui/Flex"));
const Form_1 = require("@targetx/mineral-ui/Form");
const Text_1 = __importDefault(require("@targetx/mineral-ui/Text"));
const TextInput_1 = __importDefault(require("@targetx/mineral-ui/TextInput"));
const Alert_1 = __importDefault(require("@targetx/tx-web-ui-lib/lib/components/Alert"));
const Form_2 = __importDefault(require("@targetx/tx-web-ui-lib/lib/components/Form"));
const lodash_get_1 = __importDefault(require("lodash.get"));
const react_1 = __importStar(require("react"));
const isEmpty_1 = __importDefault(require("validator/lib/isEmpty"));
const isFQDN_1 = __importDefault(require("validator/lib/isFQDN"));
const theme_1 = __importDefault(require("../../theme"));
const FindOrgForm_copyText_1 = __importDefault(require("./FindOrgForm.copyText"));
exports.ERROR_INVALID_SID = 'ERROR_INVALID_SID';
exports.ERROR_UNEXPECTED = 'ERROR_UNEXPECTED';
function FindOrgForm({ action, csrfToken, errorMessageKey: _errorMessageKey, redirectURL }) {
    const initialState = {
        errorMessageKey: _errorMessageKey,
        orgSIDInput: ''
    };
    const [state, setState] = (0, react_1.useState)(initialState);
    function changeState(partialState) {
        setState(currentState => ({ ...currentState, ...partialState }));
    }
    const { errorMessageKey, orgSIDInput } = state;
    function handleChange(event) {
        const { name, value } = event.target;
        changeState({ [`${name}Input`]: value, errorMessageKey: undefined });
    }
    return (react_1.default.createElement(Flex_1.default, { as: Form_2.default, action: action, direction: "column", height: "fit-content", method: "post", paddingHorizontal: theme_1.default.space_inline_xxs, scrollable: true },
        react_1.default.createElement(Text_1.default, { as: "h1", align: "center", fontSize: "1.5rem", fontWeight: "semiBold" }, FindOrgForm_copyText_1.default.title),
        react_1.default.createElement(Text_1.default, { align: "center", fontSize: theme_1.default.fontSize_base, marginBottom: theme_1.default.space_stack_sm, marginTop: theme_1.default.space_stack_md }, FindOrgForm_copyText_1.default.instructions),
        renderErrorMessage({ errorMessageKey }),
        react_1.default.createElement(Form_1.FormField, { name: "orgSID", label: FindOrgForm_copyText_1.default.sidInputLabel, hideLabel: true, input: TextInput_1.default, marginBottom: theme_1.default.space_stack_lg, required: true, value: orgSIDInput, variant: errorMessageKey === exports.ERROR_INVALID_SID || !isValid(orgSIDInput)
                ? 'danger'
                : undefined, onChange: handleChange }),
        react_1.default.createElement("input", { type: "hidden", name: "_csrf", value: csrfToken }),
        react_1.default.createElement("input", { type: "hidden", name: "redirectURL", value: redirectURL }),
        react_1.default.createElement(Button_1.default, { disabled: orgSIDInput.length === 0 || !isValid(orgSIDInput), fullWidth: true, primary: true, type: "submit" }, FindOrgForm_copyText_1.default.submitButtonLabel)));
}
exports.FindOrgForm = FindOrgForm;
function isValid(value) {
    return (0, isEmpty_1.default)(value) || (0, isFQDN_1.default)(value, { require_tld: false });
}
function renderErrorMessage({ errorMessageKey }) {
    if (!errorMessageKey)
        return null;
    return (react_1.default.createElement(Alert_1.default, { marginBottom: theme_1.default.space_stack_md, title: (0, lodash_get_1.default)(FindOrgForm_copyText_1.default, `${errorMessageKey}_title`), variant: "danger" }, (0, lodash_get_1.default)(FindOrgForm_copyText_1.default, `${errorMessageKey}_message`)));
}
FindOrgForm.ERROR_INVALID_SID = exports.ERROR_INVALID_SID;
FindOrgForm.ERROR_UNEXPECTED = exports.ERROR_UNEXPECTED;
exports.default = FindOrgForm;
